import type { ReactNode } from 'react'
import React from 'react'

import MessageBox from '../../../Atoms/MessageBox'

interface IInfoProps {
  children: ReactNode
}

export const Info = (props: IInfoProps) => {
  const { children } = props

  return (
    <MessageBox kind="info">
      <MessageBox.Title>{children}</MessageBox.Title>
    </MessageBox>
  )
}

Info.displayName = 'Card.Info'
